  export const syles = {
    cropsMenu: {
      width: "100%",
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "10px",
      paddingBottom: "30px",
    },
    cropsSelector: {
      width: "200px",
      height: "40px",
      marginRight: "10px",
    },
  };